import HomeIcon from "@mui/icons-material/Home";
import { Button, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MapChapterProps } from "../Map";

export const MapChapterHeader: FC<MapChapterProps> = ({
  chapterPath: chapter,
  color,
}) => {
  //  CONTEXTS
  const { t } = useTranslation();

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      p={4}
      spacing={2}
      wrap="wrap"
    >
      <Grid item xs={12}>
        <Typography variant="h2" sx={{ color: "grey.700" }}>
          {t(`ui.info.${chapter.replace("/", "")}.name`)}
        </Typography>
      </Grid>
      <Grid item>
        <Link to="/">
          <Button variant="contained" color={color}>
            <HomeIcon />
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};
